import React, { useState } from 'react'
import './Community.css'
import Select from 'react-select';


export default function EditPostCommunity({ handleEditPostPopUpFalse }) {

    // drodowon css
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            height: '38px',
            width: '100%',
            borderRadius: '6px',
            padding: ' 1px',
            border: '1px solid #99ADBB',
            fontFamily: "MinecrafterReg.ttf",
            background: 'white',
            fontSize: '12px',
            fontWeight: '600'

        }),
        menu: (provided, state) => ({
            ...provided,
            // width: state.selectProps.menuWidth || 'auto', // Set the width to 10px when menuWidth is set
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: 'white',
            fontSize: '12px',
            color: 'black', // Change the background color when the option is hovered over
            '&:hover': {
                boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
                color: '#F77F00',
                borderRadius: '5px',
                fontWeight: '700'

            },
        }),
        indicatorSeparator: () => ({ display: "none" }),
    };
    const optionsQuery = [
        { value: 'Xploresense School', label: ' Xploresense School' },
        { value: 'Xploresense School2', label: ' Xploresense School2' },

    ];
    const optionsaddTag = [
        { value: 'Exhibition', label: ' Exhibition' },
        { value: 'Social Expo 2022', label: ' Social Expo 2022' },

    ];
    const [selectedOption, setSelectedOption] = useState(optionsQuery[0]);
    const [textareaValue, setTextareaValue] = useState('The expo begins with an account of science in ancient India and the countrys achievements in the preIndependence period.');

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
    };

    const [selectedTagOption, setSelectedTagOption] = useState(optionsaddTag[0]);
    const handleTagChange = (selectedTagOption) => {
        setSelectedTagOption(selectedTagOption);
    };

    const handleTextareaChange = (event) => {
        setTextareaValue(event.target.value);
    }
    return (
        <div className='ContainerCreatePostCommunity'>
            <div className='SubContainerCreatePostCommunity'>
                <div>
                    <img onClick={handleEditPostPopUpFalse} style={{ cursor: 'pointer' }} className='CrossIconPost' src='/Enggagement/crossCirclePost.png' alt=''></img>
                </div>
                <div className='d-flex justify-content-between '>
                    <div>
                        <div className='creatPostHeaidng' >Create new post</div>
                        <div className='lastUpdate'>Last updated on 25-07-2022</div>
                    </div>
                    <div className='d-flex align-items-center gap-2'>
                        <div>
                            <img src='/Enggagement/ProifleCommunity.png' alt='' />
                        </div>
                        <div className='nameUser'>
                            Xploresense School
                        </div>
                    </div>
                </div>

                <div className='mt-4'>
                    <Select
                        options={optionsQuery}
                        value={selectedOption}
                        onChange={handleChange}
                        placeholder="Select Channel"
                        styles={customStyles}
                    />
                </div>
                <div className='mt-3'>
                    <Select
                        options={optionsaddTag}
                        value={selectedTagOption}
                        onChange={handleTagChange}
                        placeholder="Add Tags"
                        styles={customStyles}
                        isMulti
                    />
                </div>
                <div className='mt-3'>
                    <textarea
                        className='DescriptiontextCreatePost'
                        placeholder='Add Tags'
                        value={textareaValue}
                        onChange={handleTextareaChange}
                    />
                </div>

                <div className='d-flex justify-content-between mt-3 align-items-center'>
                    <div className='pt-2'>
                        <input type="file" id="attachFile" accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx,.mp3,.mp4" style={{ display: "none" }} />
                        <label htmlFor="attachFile">
                            <div className='d-flex align-items-center gap-1'>
                                <div>
                                    <img src='/Enggagement/AttachIcon.png' alt='' />
                                </div>
                                <div className='attachFileText'>Attach File</div>
                            </div>
                        </label>
                    </div>
                    <div>
                        <button className='PostComunityBtn'>Post</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
